import { render, staticRenderFns } from "./LocationTrigger.vue?vue&type=template&id=5b31864a&scoped=true"
import script from "./LocationTrigger.vue?vue&type=script&lang=js"
export * from "./LocationTrigger.vue?vue&type=script&lang=js"
import style0 from "./LocationTrigger.vue?vue&type=style&index=0&id=5b31864a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31864a",
  null
  
)

export default component.exports